import { render, staticRenderFns } from "./digitalTwin.vue?vue&type=template&id=1b0324c8&scoped=true"
import script from "./digitalTwin.vue?vue&type=script&lang=js"
export * from "./digitalTwin.vue?vue&type=script&lang=js"
import style0 from "./digitalTwin.vue?vue&type=style&index=0&id=1b0324c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0324c8",
  null
  
)

export default component.exports